import PDLTypography from "../../../components/dna/_pdltypography";
import { Pagination } from "../../../components/global";
import ResultItem from "../../../components/pages/resultados/_resultItem";

interface SavedItemsListProps {
  items: any[];
  searchTerm?: string;
  onRemove?: (item: any) => void;
}

const SavedItemsList = ({
  items,
  searchTerm = "",
  onRemove,
}: SavedItemsListProps) => {
  if (items.length === 0) {
    return (
      <PDLTypography size="sm" className="text-muted">
        Nenhum item encontrado
      </PDLTypography>
    );
  }

  return (
    <>
      <div className="results-container">
        {items.map((item, index) => {
          const getItemType = (): string => {
            const tipoValido = item?.tipo?.toLowerCase();
            if (
              [
                "jurisprudencia",
                "legislacao",
                "doutrinas",
                "modelos",
                "peticoes",
              ].includes(tipoValido)
            ) {
              return tipoValido;
            }

            if (item?.tribunal) return "jurisprudencia";
            if (item?.autores || item?.autor) return "doutrinas";
            if (item?.nome || item?.id || item?.numero || item?.tipo_doc)
              return "legislacao";
            if (item?.titulo) return "modelos";

            return "peticoes";
          };

          return (
            <ResultItem
              key={index}
              item={item as any}
              tipo={getItemType() as any}
              index={index}
              pushDown={true}
              cardProfileStyle={true}
              onRemove={onRemove as any}
            />
          );
        })}
      </div>
      {items.length > 0 && (
        <div className="mt-4">
          <Pagination
            currentPage={1}
            totalPages={5}
            onPageChange={() => {}}
            showFirstLast={true}
            showPrevNext={true}
            maxVisiblePages={5}
            size="md"
          />
        </div>
      )}
    </>
  );
};

export default SavedItemsList;
